<template>
    <li class="vue-progress-indicator">
        <a href="#" class="indicator-handle" data-toggle="dropdown" @click.prevent="toggleVisibility">
            <span class="glyphicon glyphicon-align-left menu-glyphicon"></span>

            <span class='badge progress-bar-info' v-if="hasProgress">{{items.length}}</span>
        </a>

        <div v-if="hasProgress" :style="{display: listVisible ? 'block' : 'none'}" class="dropdown-menu progress-list-container">
            <div class="errorMsg bg-danger well-sm" v-if="this.errorMsg.length">
                {{errorMsg}}
            </div>
            <ul class='list-group' v-if="hasProgress">
                <progress-bar v-for="i in this.items" :progress="i"></progress-bar>
            </ul>
        </div>
    </li>
</template>

<script>
    import axios from '@/api/client'
    import ProgressBar from '@/components/ProgressBar'

    export default {
        props: {
//            destinationPath: {
//                type: String,
//                required: true
//            },
//            userId: {
//                type: Number,
//                required: true
//            }
        },
        name: 'ProgressIndicator',
        data () {
            return {
                items: [],
                listVisible: false,
                errorMsg: ''
            }
        },
        computed: {
            hasProgress: function () {
                return this.items.length > 0 || this.errorMsg.length
            }
        },
        methods: {
            toggleVisibility: function (e) {
                this.listVisible = !this.listVisible

                if (this.listVisible) {
                    document.addEventListener('click', this.hide)
                    document.addEventListener('keyup', this.hide)
                } else {
                    document.removeEventListener('click', this.hide)
                    document.removeEventListener('keyup', this.hide)
                }
            },
            deleteItem: async function (item) {
                try {
                    this.errorMsg = ''
                    const response = await axios.delete('/rest/user/' + this.userId + '/notifications/' + item.id)

                    if (response.data.result !== true) {
                        this.errorMsg = response.data.message
                    }
                } catch (err) {
                    this.errorMsg = err.message
                }
            },
            hide (e) {
                if (this.listVisible && !this.$el.contains(e.target)) {
                    this.toggleVisibility(e)
                }
            }
        },
        created () {
            const self = this
            if ('serviceWorker' in navigator) {
                // Handler for messages coming from the service worker
                navigator.serviceWorker.addEventListener('message', function (event) {
                    if (Array.isArray(event.data)) {
                        self.items = event.data.filter(datum => {
                            return (datum.module === 'Progress')
                        })
                    } else {
                        if (event.data.mode === 'delete') {
                            self.items = self.items.filter(datum => {
                                return (datum.id !== event.data.payload.id)
                            })
                        } else if (event.data.payload.module === 'Progress') {
                            if (event.data.mode === 'update') {
                                for (let item in self.items) {
                                    if (self.items[item].id === event.data.payload.id) {
                                        self.items[item] = event.data.payload
                                    }
                                }
                            } else {
                                self.items.push(event.data.payload)
                            }
                        }
                    }
                    self.$forceUpdate()
                })
            }
        },
        mounted () {
//            this.toggleVisibility()
        },
        components: { ProgressBar }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ProgressIndicator.vue?c1c22014